"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputAddOn = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// children must be an input
var InputAddOn = exports.InputAddOn = function InputAddOn(_ref) {
  var children = _ref.children,
    leftAddon = _ref.leftAddon,
    rightAddon = _ref.rightAddon,
    height = _ref.height,
    width = _ref.width;
  var feedbackStyles = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    position: 'absolute',
    top: 0
  }, leftAddon ? 'left' : 'right', 0), "zIndex", 2), "display", 'block'), "width", width || '38px'), "height", height || '42px'), "lineHeight", height || '42px'), "textAlign", 'center'), "color", 'red');
  var childrenStyle = leftAddon || rightAddon ? _defineProperty({}, leftAddon ? 'paddingLeft' : 'paddingRight', '42.5px') : {};
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative'
    },
    className: "input-feedback"
  }, leftAddon && /*#__PURE__*/_react.default.createElement("div", {
    style: feedbackStyles,
    "aria-hidden": "true"
  }, leftAddon), /*#__PURE__*/_react.default.cloneElement(children, {
    style: childrenStyle
  }), rightAddon && /*#__PURE__*/_react.default.createElement("div", {
    style: feedbackStyles,
    "aria-hidden": "true"
  }, rightAddon));
};
InputAddOn.propTypes = {
  children: _propTypes.default.element,
  leftAddon: _propTypes.default.element,
  rightAddon: _propTypes.default.element,
  height: _propTypes.default.string,
  width: _propTypes.default.string
};